import React from "react";
import "./Upgrade.css";

const Upgrade = () => {
  return (
    <div className="upgrade-section">
      <div className="upgrade-content">             
        <h2>You're almost there!</h2>
        <p>To access our amazing learning resources, please upgrade your account.</p>
        <p>Contact our support team to unlock access and start learning.</p>
      </div>
    </div>
  );
};

export default Upgrade;